import {Component, input, output} from '@angular/core';
import {TranslatePipe} from '@ngx-translate/core';

export interface SideNavItem<T> {
  value: T;
  label: string;
}

@Component({
  selector: 'elcia-side-nav',
  imports: [TranslatePipe],
  templateUrl: './side-nav.html',
  styleUrl: './side-nav.scss',
})
export class SideNav<T> {
  items = input.required<SideNavItem<T>[]>();
  activeValue = input.required<T>();
  valueChange = output<T>();

  itemClass(value: T): string {
    const base = 'w-full text-left px-4 py-2 rounded-lg text-sm font-medium transition-colors duration-150 cursor-pointer border-l-2';
    return this.activeValue() === value
      ? `${base} bg-primary-50 text-primary-500 border-primary-500`
      : `${base} text-gray-500 border-transparent hover:bg-gray-100`;
  }
}
